import { Button, Flex, Icon, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiCornerUpLeft } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { FrameworkRole, useGetFrameworkAgreementQuery } from "../../../autogen/bff-api";
import { urls } from "../../../urls";

export const FrameworkAgreementLink = ({
  frameworkAgreementId,
  role,
  mayOpen,
}: {
  frameworkAgreementId: string;
  role?: FrameworkRole | null;
  mayOpen: boolean;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: framework } = useGetFrameworkAgreementQuery({ frameworkAgreementId }, { skip: !mayOpen });

  return (
    <Flex align="center" gap="2" flexWrap="wrap">
      <Text fontSize="sm" color="smMuted">
        {role === FrameworkRole.CallOff ? t("CallOff") : t("FrameworkSupplierContract")}
      </Text>
      {mayOpen ? (
        <Button
          variant="link"
          size="sm"
          colorScheme="teal"
          leftIcon={<Icon as={FiCornerUpLeft} />}
          onClick={() => navigate(urls.app.frameworkAgreements.view.go(frameworkAgreementId))}
        >
          {framework?.title ?? t("Framework agreement")}
        </Button>
      ) : (
        <Text fontSize="sm">{t("Framework agreement")}</Text>
      )}
    </Flex>
  );
};
